import axios from 'axios'

export default  {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    find({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/admin/exam-sample-scans/${id}`)
          .then((res) => {
            resolve(res.data.data.exam_sample_scan)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    create({commit}, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/admin/exam-sample-scans', data)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    update({commit}, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/admin/exam-sample-scans/${data.id}`, data)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getItemSerials({commit}, {itemId, examSampleScanId}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/exam-sample-scans/${examSampleScanId}/get-item-serials`, {
            params: {
              item_id: itemId
            }
          })
          .then(res => {
            resolve(res.data.data.itemSerials)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    saveItemSerials({commit}, itemSerialsData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/exam-sample-scans/${itemSerialsData.exam_sample_scan_id}/items/save-serials`, itemSerialsData)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    addItemDetail({commit}, itemDetailData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/exam-sample-scans/${itemDetailData.exam_sample_scan_id}/items/save-detail`, itemDetailData)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },

  getters: {},
}
